import React, { Component } from "react";

import PropTypes from "prop-types";
import Tabs from "./Tabs";
import { injectIntl } from "react-intl";

/**
 * Component which hosts tabs and allows dropping of existing pages from the template.
 */
class PagesPanel extends Component {
  handleDrop(event) {
    let dragData = JSON.parse(event.dataTransfer.getData("text"));

    if (dragData.type === "page") {
      this.props.addPage(dragData.page);
    }
    event.stopPropagation();
    event.preventDefault();
  }

  handleDragOver(event) {
    event.preventDefault();
  }

  render() {
    return (
      <div id="pagesPanel" onDrop={this.handleDrop.bind(this)} onDragOver={this.handleDragOver.bind(this)}>
        <Tabs {...this.props} />
      </div>
    );
  }
}

PagesPanel.propTypes = {
  addPage: PropTypes.func
};

export default injectIntl(PagesPanel);
